module.exports = __webpack_public_path__ + "img/staff-2015-broadcast.fedd1089.jpg";